import * as L from 'leaflet';

export class ControlBar extends L.Control {
  private controls: L.Control[] = [];
  constructor(options: L.ControlOptions & {controls: L.Control[]}) {
    super(options);

    this.controls = options.controls || [];
  }

  onAdd(map: L.Map) {
    const buttonContainer = L.DomUtil.create('div', 'leaflet-bar');
    L.DomEvent.disableClickPropagation(buttonContainer);

    this.controls.forEach(ctrl => {
      const controlElement = ctrl.onAdd(map);

      buttonContainer.appendChild(controlElement);
    })

    return buttonContainer;
  }
}
